import { createFileRoute, redirect } from "@tanstack/react-router";
import { EventsPage } from "../../components/participant/events-page";
import { meProfileQuery } from "../../lib/api/me";

/** `/me/events` — athletes only (an approved `Aa` card); anyone else goes to their profile. The API answers an empty list regardless. */
export const Route = createFileRoute("/_app/me/events")({
	beforeLoad: async ({ context }) => {
		const profile = await context.queryClient.ensureQueryData(meProfileQuery);
		if (!profile.is_athlete) throw redirect({ to: "/me", replace: true });
	},
	component: EventsPage,
});
